3 // import * as utils from '@/utils/utils';

import services from '../services/cockpit.js'

const {
  getStatistics,
  getMembershipData,
  getPaymentData,
  getMemberMapData,
  getMemberOtherData,
  getMembershipMapData,
  getMembershipOtherData,
  getPaymentTotalData,
  getPaymentChartData,
  getMemberTypes,
  getServiceTypes,
} = services

const namespace = 'cockpit'

export default {
  namespace,
  state: {
    // 会员统计看板数据
    statistics: {
      companySortList: [],
    },
    // 入会统计看板数据
    membershipData: {},
    // 缴费统计看板数据
    paymentData: {},
  },
  reducers: {
    updateState(state, { payload }) {
      return {
        ...state,
        ...payload,
      }
    },
  },
  effects: {
    // 会员统计看板数据
    *getStatistics({ payload, callback }, { call, put }) {
      const res = yield call(getStatistics, { ...payload })
      if (res && res.success) {
        yield put({
          type: 'updateState',
          payload: {
            statistics: res.data,
          },
        })
        callback && callback(res.data)
      }
    },

    *getMemberMapData({ callback }, { call, put }) {
      const res = yield call(getMemberMapData)
      if (res && res.success) {
        callback(res.data)
      }
    },

    *getMemberOtherData({ callback, payload }, { call, put }) {
      const res = yield call(getMemberOtherData, payload)
      if (res && res.success) {
        callback(res.data)
      }
    },
    *getServiceTypes({ callback }, { call }) {
      const res = yield call(getServiceTypes)
      if (res && res.success) {
        callback(res.data)
      }
    },

    // 入会统计看板数据
    *getMembershipData({ payload, callback }, { call, put }) {
      const res = yield call(getMembershipData, { ...payload })
      if (res && res.success) {
        yield put({
          type: 'updateState',
          payload: {
            membershipData: res.data,
          },
        })
        callback && callback(res.data)
      }
    },

    *getMembershipMapData({ callback }, { call }) {
      const res = yield call(getMembershipMapData)
      if (res && res.success) {
        callback(res.data)
      }
    },
    *getMembershipOtherData({ callback, payload }, { call }) {
      const res = yield call(getMembershipOtherData, payload)
      if (res && res.success) {
        callback(res.data)
      }
    },

    // 缴费统计看板数据
    *getPaymentData({ payload, callback }, { call, put }) {
      const res = yield call(getPaymentData, { ...payload })
      if (res && res.success) {
        yield put({
          type: 'updateState',
          payload: {
            paymentData: res.data,
          },
        })
        callback && callback(res.data)
      }
    },

    *getPaymentTotalData({ callback }, { call }) {
      const res = yield call(getPaymentTotalData)
      if (res && res.success) {
        callback(res.data)
      }
    },
    *getPaymentChartData({ callback, payload }, { call }) {
      const res = yield call(getPaymentChartData, payload)
      if (res && res.success) {
        callback(res.data)
      }
    },
    *getMemberTypes({ callback }, { call }) {
      const res = yield call(getMemberTypes)
      if (res && res.data) {
        callback(res.data)
      }
    },
  },
  // 订阅事件
  subscriptions: {},
}
